import { createContext, useContext } from "react";

export interface Failure {
  message: string;
  /** The failed request's trace id, when the server sent one. */
  reference?: string;
}

export interface FailureContextValue {
  /**
   * Raise the anchored failure bar. One slot: a second failure replaces the first rather than
   * stacking, because two bars eat the page and the older reference is the less useful of the two.
   */
  showFailure: (message: string, reference?: string) => void;
  clearFailure: () => void;
}

export const FailureContext = createContext<FailureContextValue | undefined>(undefined);

export function useFailure(): FailureContextValue {
  const ctx = useContext(FailureContext);
  if (!ctx) {
    throw new Error("useFailure must be used within a FailureProvider");
  }
  return ctx;
}
